import { DetailedHTMLProps, IframeHTMLAttributes } from "react"
import { Box, styled, SxProps, useTheme } from "@mui/material"
import { deepmerge } from "@mui/utils"
import { BaseModal, IBaseModalProps } from "components/modal"

const IFrame = styled("iframe")(() => ({}))
export interface IIframeModalProps extends Omit<IBaseModalProps, "children"> {
  src: string
  iframeProps?: DetailedHTMLProps<
    IframeHTMLAttributes<HTMLIFrameElement>,
    HTMLIFrameElement
  > & { sx?: SxProps }
}

export const IframeModal: React.FC<IIframeModalProps> = ({
  src,
  iframeProps = {},
  sx = {},
  ...props
}) => {
  const theme = useTheme()
  const styleOverrides = theme.components[`IframeModal`]?.styleOverrides || {}
  const { root, contentContainer, iframe } = styleOverrides
  const { iframeOptions = {} } =
    theme.components[`IframeModal`]?.defaultProps || {}

  return (
    <BaseModal sx={deepmerge(root, sx)} {...props}>
      <Box sx={contentContainer}>
        <IFrame
          {...iframeOptions}
          {...iframeProps}
          sx={deepmerge(iframe, iframeProps?.sx || {})}
          src={src}
        />
      </Box>
    </BaseModal>
  )
}
